import { useTranslation } from 'react-i18next';
import { LANGUAGE_OVERRIDE_KEY } from '@/hooks/useAuth';

/** EN / FR / NL segmented switch. 'glass' on gradient, 'paper' on light bars. */
export function LangSwitcher({ variant = 'glass' }: { variant?: 'glass' | 'paper' }) {
  const { i18n } = useTranslation();

  function pick(lang: string) {
    // Explicit user choice — wins over the account languagePref from now on.
    localStorage.setItem(LANGUAGE_OVERRIDE_KEY, '1');
    void i18n.changeLanguage(lang);
  }

  const shell =
    variant === 'glass'
      ? 'bg-white/[0.08] border-white/[0.15]'
      : 'bg-slate-100 border-slate-200';

  return (
    <div className={`flex items-center gap-1 rounded-lg p-1 w-fit border ${shell}`}>
      {(['EN', 'FR', 'NL'] as const).map((l) => {
        const active = i18n.language.toLowerCase().startsWith(l.toLowerCase());
        const cls =
          variant === 'glass'
            ? active
              ? 'bg-white/20 text-white'
              : 'text-white/60 hover:text-white/90'
            : active
              ? 'bg-white text-brand-rose shadow-sm'
              : 'text-slate-500 hover:text-ink';
        return (
          <button
            key={l}
            type="button"
            onClick={() => pick(l.toLowerCase())}
            className={`px-3 py-1.5 text-xs font-semibold rounded-md transition-colors ${cls}`}
          >
            {l}
          </button>
        );
      })}
    </div>
  );
}
